module.exports = __webpack_public_path__ + "static/media/img_4-4.b0d924f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/v2/img_4-4.png
// module id = 729
// module chunks = 0